import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, className }) => {
  return (
    <section className={className}>
      <form id={attributes.formId} className="wrapper">

        <RichText.Content
          tagName="h1"
          className={`${className}-title`}
          value={attributes.title}
        />

        <RichText.Content
          tagName="p"
          className={`${className}-subtitle`}
          value={attributes.subtitle}
        />

        <div className='wp-block-custom-form-block-errorBox' id="error-box">
          <p className='wp-block-custom-form-block-errorBox-text' id="error-text"></p>
        </div>

        <InnerBlocks.Content />
      </form>
    </section>
  )
}
